<template>
    <div v-if="className == 'sub-tab-wrap'" class="mt-lg-n60">
        <template v-for="item in gnbs">
            <ul class="tab tab--block" :key="item.title" v-if="item.title == sh">
                <li v-for="child in item.children" :key="child.title" class="tab__li" :class="{'active' : tabActive == child.title}">
                    <a :href="child.path" class="tab__btn"><span>{{child.title}}</span></a>
                </li>
            </ul>
        </template>
    </div>
    <ul v-else-if="className == 'gnb'" :class="className">
        <template v-for="item in gnbs">
            <li v-if="!item.children" :class="className+'__li'" :key="item.title">
                <router-link :to="item.path" :class="className+'__link'"><h2>{{item.title}}</h2></router-link>
            </li>

            <li v-else :class="className+'__li'" :key="item.title">
                <div v-if="isMobile" :class="className+'__link gnb__link--toggle'"><h2>{{item.title}}</h2></div>
                <router-link v-else :to="item.path" :class="className+'__link gnb__link--toggle'"><h2>{{item.title}}</h2></router-link>
                <ul :class="className+'__sub'">
                    <li v-for="child in item.children" :key="child.title">
                        <router-link :to="child.path">{{child.title}}</router-link>
                    </li>
                </ul>
            </li>
        </template>
    </ul>
</template>

<script>
export default {
    props: {
        className : String,
        indexNum : String,
        sh : String,
        tabActive : String,  
    },
    data: function(){
        return {
            window: {
                width: 0,
                height: 0,
            },
            gnbs : [
                {
                    title : "기업소개",
                    path : "/introduction",
                    children : [
                        {
                            title : "기업소개",
                            path : "/introduction",
                        },
                        {
                            title : "인사말",
                            path : "/introduction/greeting",
                        },
                        {
                            title : "본사&지점",
                            path : "/introduction/office",
                        },
                        {
                            title : "보도자료",
                            path : "/introduction/press",
                        },
                        {
                            title : "기업문화",
                            path : "/introduction/culture",
                        },
                    ]
                },
                {
                    title : "사업소개",
                    path : "/business-introduction",
                    children: [
                        {
                            title: "사업분야",
                            path: "/business-introduction"
                        },
                        {
                            title: "고객사",
                            path: "/client-company"
                        },
                    ]
                },
                {
                    title : "제휴문의",
                    path : "/affiliate-inquiries",
                    children : [
                        {
                            title : "제휴안내",
                            path : "/affiliate-inquiries",
                        },
                    ]
                },
                {
                    title : "인재채용",
                    path : "/recruitment",
                    children : [
                        {
                            title : "인재상",
                            path : "/recruitment/type",
                        },
                        {
                            title : "브랜드 홍보대사",
                            path : "/ambassador",
                        },
                        {
                            title : "펀드레이저",
                            path : "/fund-laser",
                        },
                        {
                            title : "채용절차",
                            path : "/recruitment/procedure",
                        },
                        {
                            title : "현직자 인터뷰",
                            path : "/interview",
                        },
                        {
                            title : "채용 FAQ",
                            path : "/recruitment/faqs",
                        },
                    ]
                },
                {
                    title : "위치안내",
                    path : "/location",
                },
            ],
        };
    },
    computed: {
        isDesktop: function() {
            return this.window.width >= 1200;
        },
        isMobile: function() {
            return this.window.width < 1200;
        },
    },
    created: function(){
        window.addEventListener('resize', this.handleResize);
        this.handleResize();
    },
    destroyed() {
        window.removeEventListener('resize', this.handleResize);
    },
    mounted: function(){
    },
    methods: {
        handleResize: function() {
            this.window.width = window.innerWidth;
            this.window.height = window.innerHeight;
        },
    }
};
</script>